(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-tks"] && !Shopify.designMode) return;
  try {
    (() => {
    const renderHighlights = (root = document) => {
      const cards = [];

      if (root.nodeType === Node.ELEMENT_NODE && root.matches('.m-product-card--style-tks')) {
        cards.push(root);
      }

      root.querySelectorAll('.m-product-card--style-tks').forEach((card) => cards.push(card));

      cards.forEach((card) => {
        const dataElement = card.querySelector('.product-card-tks-params');
        const list = card.querySelector('.tks-product-highlights-ul');

        if (!dataElement || !list || list.dataset.initialized === 'true') return;

        try {
          const parsed = JSON.parse(dataElement.dataset.json || '{}');
          const listBlock = Array.isArray(parsed.children)
            ? parsed.children.find((child) => child && child.type === 'list')
            : null;

          list.textContent = '';

          if (listBlock && Array.isArray(listBlock.children)) {
            listBlock.children.forEach((item) => {
              const textNode = item && Array.isArray(item.children) ? item.children[0] : null;

              if (textNode && textNode.value) {
                const listItem = document.createElement('li');
                listItem.textContent = textNode.value;
                list.appendChild(listItem);
              }
            });
          }

          list.dataset.initialized = 'true';
        } catch (error) {
          console.error('Failed to render product card highlights.', error);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => renderHighlights(), { once: true });
    } else {
      renderHighlights();
    }

    document.addEventListener('shopify:section:load', (event) => renderHighlights(event.target));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) renderHighlights(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
